/**
 * Carril contextual (GEN-PX-023): lista las entradas hijas del botón del raíl pulsado, junto al raíl, como el carril de los chats.
 * Genérico: no sabe de qué botón es; pinta lo que recibe. La entrada activa se resalta y pulsar otra abre su pantalla.
 *   titulo: nombre del botón · hijos: [{id, label}] · activoId · onElegir(hijo)
 */
export default function CarrilContextual({ titulo, hijos, activoId, onElegir }) {
  return (
    <nav className="dk-carril" aria-label={titulo}>
      <h2 className="dk-carril__titulo">{titulo}</h2>
      <ul className="dk-carril__lista">
        {hijos.map(h => {
          const on = h.id === activoId
          return (
            <li key={h.id}>
              <button
                type="button"
                className={'dk-carril__entrada' + (on ? ' dk-carril__entrada--activa' : '')}
                aria-current={on ? 'page' : undefined}
                onClick={() => onElegir(h)}
              >
                {h.label}
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
